import './Resultpages.scss';

function Resultspages({
	currentPage,
	pageSize,
	totalElements
}) {
	const fromItems = currentPage * pageSize - pageSize + 1;
	const calcToItems = fromItems - 1 + pageSize;
	const toItems =
		calcToItems >= totalElements
			? totalElements
			: calcToItems;
	return (
		<div className='results-pages'>
			<span>{`From ${fromItems} to ${toItems} of ${totalElements}`}</span>
		</div>
	);
}

export default Resultspages;
